/**
 * Compliance footer (legal research items 8-10): links to the Privacy Policy and Terms of Use, and
 * a terms-acceptance line shown at the point of submit. Rendered at the bottom of the review and
 * refine screens. Links open in a new tab (Discord embeds in an iframe).
 */
export const PRIVACY_URL = 'https://pghbites.com/privacy';
export const TERMS_URL = 'https://pghbites.com/terms';

interface LegalFooterProps {
  /** When true, show the terms-acceptance line (used right by the submit action). */
  showAcceptance?: boolean;
}

export function LegalFooter({ showAcceptance = false }: LegalFooterProps) {
  return (
    <footer className="legal-footer">
      {showAcceptance && (
        <p className="legal-accept">
          By posting, you confirm you have the rights to any image link you share and agree to the{' '}
          <a href={TERMS_URL} target="_blank" rel="noreferrer noopener">
            Terms
          </a>
          .
        </p>
      )}
      <p className="legal-links">
        <span aria-hidden="true">PGH Bites 🖤💛</span>
        <a href={PRIVACY_URL} target="_blank" rel="noreferrer noopener">
          Privacy Policy
        </a>
        <a href={TERMS_URL} target="_blank" rel="noreferrer noopener">
          Terms of Use
        </a>
      </p>
    </footer>
  );
}
